export default {
  methods: {
    saveFilter(filter) {
      localStorage.setItem(this.getKey(), JSON.stringify(filter));
    },
    loadFilter() {
      const filter = localStorage.getItem(this.getKey());
      return filter && filter != undefined ? JSON.parse(filter) : null;
    },
    removeFilter() {
      localStorage.removeItem(this.getKey());
    },
    getKey() {
      const filterKeySuffix = '_filter';
      return this.$options.name !== 'DictionaryItems'
        ? this.$options.name + filterKeySuffix
        : this.$options.name + `_${this.name}` + filterKeySuffix;
    }
  }
}